<div class='full-form'>
  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetRS.record.value.properties.price.value) {
    <h2>Prezzo pacchetto a partire da <b>{{datasetRS.record.value.properties.price.value | currency:'EUR'}}</b></h2>
  }

  @if (datasetACS.ready.value) {
    <div class='mt-24'>
      <dataset-list
        #tripList
        datasetCode='actual_trips'
        [showTitle]='false'
        [parentDatasetRS]='datasetRS'
        [parentDatasetACS]='datasetACS'
        [showSearchBar]='true'
        [enableCreate]='false'
        [enableDelete]='false'
        [enableEdit]='false'
        [elevate]='false'
        [emitAdd]='true'
        [addButtonText]='"Genera"'
        [filters]='{ trip_package_id: datasetRS.recordId, start_day: todayFilter }'
        (add)='generate()'
      ></dataset-list>
    </div>
  }
</div>